import { j as C } from "../../_virtual/jsx-runtime.js";
import { c } from "../../_virtual/compiler-runtime.js";
import { cn as m } from "../../utils/cn.js";
const n = (r) => {
  const e = c.c(9);
  let o, l;
  e[0] !== r ? ({
    className: o,
    ...l
  } = r, e[0] = r, e[1] = o, e[2] = l) : (o = e[1], l = e[2]);
  let t;
  e[3] !== o ? (t = m("inline-block", o), e[3] = o, e[4] = t) : t = e[4];
  let s;
  e[5] === Symbol.for("react.memo_cache_sentinel") ? (s = /* @__PURE__ */ C.jsx("path", { d: "M8 1.25C4.27 1.25 1.25 4.27 1.25 8C1.25 11.73 4.27 14.75 8 14.75C11.73 14.75 14.75 11.73 14.75 8C14.75 4.27 11.73 1.25 8 1.25ZM8 13.02C7.36 13.02 6.85 12.51 6.85 11.87C6.85 11.23 7.36 10.72 8 10.72C8.64 10.72 9.15 11.23 9.15 11.87C9.15 12.51 8.64 13.02 8 13.02ZM9.2 8.71L8.85 8.94C8.85 9.41 8.47 9.79 8 9.79C7.53 9.79 7.15 9.41 7.15 8.94V8.37C7.15 8.05 7.33 7.76 7.61 7.61L8.43 7.19C8.79 7.01 9 6.67 9 6.29C9 5.74 8.55 5.29 8 5.29C7.55 5.29 7.15 5.59 7.04 6.02C6.92 6.47 6.44 6.74 6 6.62C5.55 6.5 5.28 6.03 5.4 5.58C5.72 4.41 6.79 3.59 8 3.59C9.49 3.59 10.7 4.8 10.7 6.29C10.7 7.33 10.12 8.26 9.19 8.71H9.2Z" }), e[5] = s) : s = e[5];
  let i;
  return e[6] !== l || e[7] !== t ? (i = /* @__PURE__ */ C.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", width: "16", height: "16", fill: "currentColor", role: "img", focusable: "false", className: t, ...l, children: s }), e[6] = l, e[7] = t, e[8] = i) : i = e[8], i;
};
n.displayName = "TooltipIcon";
export {
  n as TooltipIcon
};
